import React from 'react';
import { Grid } from 'semantic-ui-react';
import CohortName from '../containers/CohortName';
import CohortVisibilityChanger from '../containers/CohortVisibilityChanger';
import CohortDescription from '../containers/CohortDescription';
import CohortVisualisationCompact from '../visualisations/components/CohortVisualisationCompact';
import QueryDictionariesHeader from '../queries/containers/QueryDictionariesHeader';

const CohortInfoGridCompact = ({
  code,
  category,
  allowCohortVisualisations,
  chartType,
  queryAccess,
  selectChart,
  isNew,
  queryUUID,
}) => (
  <>
    {queryUUID && isNew && (<QueryDictionariesHeader code={code} category={category} queryUUID={queryUUID} as="h2" />)}
    {!isNew && (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column width={10}>
            <CohortName code={code} category={category} errorCoordinate="t-45" />
          </Grid.Column>
          <Grid.Column width={6} textAlign="right">
            <CohortVisibilityChanger code={code} category={category} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <CohortDescription code={code} category={category} mobilePadding />
    </>
    )}
    {queryAccess && (
    <CohortVisualisationCompact
      category={category}
      code={code}
      allowCohortVisualisations={allowCohortVisualisations}
      chartType={chartType}
      queryAccess={queryAccess}
      selectChart={selectChart}
    />
    )}
  </>
);

export default CohortInfoGridCompact;
